import React, { useState } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

import YesNoModal from 'components/Modals/yesNoModal';
import { userRoles } from 'util/appConstants';
import { getConfig } from 'functions/getConfig';
import { colors } from 'global/colors';
import Tags from '../../components/Tags';
import { Link } from '../../components';
import { Button, LinkButton } from '../../components/index';
import {
  CardContainer,
  Image,
  ChallengeInfo,
  ChallengeName,
  ChallengeInfoHeader,
  ChallengeDetails,
  DetailsLabel,
  ButtonContainer,
} from '../cmsAllChallenges/styles';

export default function ContestCard({ userRole, image, contest, link, deleteContest }) {
  const history = useHistory();

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [modalInfo, setModalInfo] = useState({});

  return (
    <>
      {showConfirmationModal && (
        <YesNoModal
          modalInfo={modalInfo}
          confirm={(isConfirmed) => {
            if (isConfirmed) deleteContest();
            setModalInfo({});
            setShowConfirmationModal(false);
          }}
        />
      )}
      <CardContainer minHeight="330px" maxWidth="400px">
        <Link to={link}>
          <Image image={image} />
        </Link>
        <ChallengeInfo>
          <ChallengeInfoHeader>
            <ChallengeName>{contest.name}</ChallengeName>
            <Tags
              isTestTag
              tags={[contest.isActive ? 'Active' : 'Inactive']}
              tagColor={contest.isActive ? colors.green2 : colors.red}
            />
          </ChallengeInfoHeader>
          <ChallengeDetails>
            <DetailsLabel>Start date:&nbsp;</DetailsLabel>
            {moment(contest.startDate).format('ll')}
          </ChallengeDetails>
          <ChallengeDetails>
            <DetailsLabel>End date:&nbsp;</DetailsLabel>
            {moment(contest.endDate).format('ll')}
          </ChallengeDetails>
          <ChallengeDetails>
            <DetailsLabel>Total submissions:&nbsp;</DetailsLabel>
            {contest.totalSubmissions ?? 0}
          </ChallengeDetails>
          <ChallengeDetails>
            <DetailsLabel>Total Participants:&nbsp;</DetailsLabel>
            {contest.noOfParticipants ?? 0}
          </ChallengeDetails>
          <ChallengeDetails>
            <DetailsLabel>Total Run:&nbsp;</DetailsLabel>
            {contest.runCount ?? 0}
          </ChallengeDetails>

          <ButtonContainer>
            <LinkButton
              primaryGreenBorder
              small
              fontSize="9px"
              padding="5px 5px"
              useMargin="1px 0 1px 3px"
              primaryBlue
              href={`${getConfig().REACT_URL}/cms/contest/${contest._id}`}
            >
              <i className="fa fa-pencil-square-o" style={{ marginRight: '2px' }}></i>Edit
            </LinkButton>
            <LinkButton
              primaryGreenBorder
              small
              fontSize="9px"
              padding="5px 5px"
              useMargin="1px 0 1px 3px"
              primaryBlue
              href={`${getConfig().REACT_URL}/challenges/${contest._id}`}
            >
              <i className="fa fa-external-link" style={{ marginRight: '2px' }}></i>Visit
            </LinkButton>
            <Button
              primaryGreenBorder
              small
              fontSize="9px"
              padding="5px 5px"
              margin="1px 0 1px 3px"
              primaryBlue
              onClick={() => {
                history.push({
                  pathname: '/cms/result',
                  state: {
                    contestId: contest._id,
                    isTournament: contest.isTournament,
                    contest: contest,
                  },
                });
              }}
            >
              <i className="fa fa-list-alt" style={{ marginRight: '2px' }}></i>
              Result
            </Button>
            {userRole === userRoles.SUPER_ADMIN && (
              <Button
                primaryRed
                small
                fontSize="9px"
                padding="5px 5px"
                margin="1px 0 1px 3px"
                onClick={() => {
                  setShowConfirmationModal(true);
                  setModalInfo({
                    title: 'Confirmation',
                    body: `Do you want to delete ${contest.name}?`,
                  });
                }}
              >
                <i className="fa fa-trash-o" style={{ marginRight: '2px' }}></i>Delete
              </Button>
            )}
          </ButtonContainer>
        </ChallengeInfo>
      </CardContainer>
    </>
  );
}
